import {
    WorkspaceDatePicker
} from "../../../Domain/SubWorkspaceManagment/SubWorkapaceSettings/generalSettings/WorkspaceDatePicker";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import ConditionalComponent from "../../../Shared/ConditionalComponent";
import Tooltip from "@mui/material/Tooltip";


export const DateInput =({settings})=>{
    return (

            <div
                className={`flex flex-row h-10 justify-between items-center border-2 border-nav-normal rounded-3 justify-between mb-2 ml-2 ${settings.value === null ? 'pl-5 py-1' : 'pl-2 py-2'}`}>
                <ConditionalComponent if={settings.value !== null}>
                    <CloseIcon sx={{color: 'var(--main-normal-color)', cursor: 'pointer', fontSize: '20px'}} onClick={()=>{settings.onChange(null)}}/>

                </ConditionalComponent>
                <Tooltip title={settings.title} placement="top" componentsProps={{tooltip: {
                        className: '!bg-main-normal color-white font-bold text-m',
                    }}}>
                <div style={{width: settings.value === null ?'160px' :'152px'}}>
                    <WorkspaceDatePicker key={settings.title} settings={settings}/>
                </div>
                </Tooltip>

            </div>

    )
};